var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Prop, Vue } from 'vue-property-decorator';
let ExpansionPanelDialog = class ExpansionPanelDialog extends Vue {
    // #endregion
    // #region @Refs
    // #endregion
    // #region Class properties
    // #endregion
    // #region Lifecycle Hooks
    // #endregion
    // #region Event handlers
    onClose() {
        this.$emit('close');
    }
    onSubmit() {
        this.$emit('submit');
    }
    onPanelClick(panelIndex) {
        const panel = this.options.panels[panelIndex];
        if (!panel)
            return;
        if (panel.disabled) {
            panel.isOpen = false;
            return;
        }
        panel.isOpen = !panel.isOpen;
    }
    // #endregion
    // #region Class methods
    // #endregion
    // #region Async methods (api calls only)
    // #endregion
    // #region Getters & Setters
    get isSinglePanel() {
        return this.options.panels.length === 1;
    }
    get normalizedOptions() {
        return {
            hasSubmitButton: true,
            secondaryButtonText: this.$tc('Cancel'),
            isValid: true,
            ...this.options,
        };
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", Object)
], ExpansionPanelDialog.prototype, "options", void 0);
ExpansionPanelDialog = __decorate([
    Component({})
], ExpansionPanelDialog);
export default ExpansionPanelDialog;
// #endregion
// #region Constants
// #endregion
